import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3WithoutDot} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section6Text71a = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {landDescription} = context.data.pdfData;

  return (
    <div ref={ref}>
      <div className={classnames(styles.itemText, styles.innerPadding)}>
        <span className={styles.bold}>{getBreakLinesTextShumaType3WithoutDot(landDescription)} </span>
      </div>
    </div>
  );
});

export default Section6Text71a;
